export const ptCountriesList = [
  {
    morningstarStandardizedName: "Mozambique",
    isoCountryCode: "MZ",
    name: "Moçambique",
  },
  {
    morningstarStandardizedName: "France",
    isoCountryCode: "FR",
    name: "França",
  },
  {
    morningstarStandardizedName: "Tonga",
    isoCountryCode: "TO",
    name: "Tonga",
  },
  {
    morningstarStandardizedName: "Ireland",
    isoCountryCode: "IE",
    name: "Irlanda",
  },
  {
    morningstarStandardizedName: "Greece",
    isoCountryCode: "GR",
    name: "Grécia",
  },
  {
    morningstarStandardizedName: "Peru",
    isoCountryCode: "PE",
    name: "Peru",
  },
  {
    morningstarStandardizedName: "Lithuania",
    isoCountryCode: "LT",
    name: "Lituânia",
  },
  {
    morningstarStandardizedName: "Qatar",
    isoCountryCode: "QA",
    name: "Catar",
  },
  {
    morningstarStandardizedName: "Comoros",
    isoCountryCode: "KM",
    name: "Comores",
  },
  {
    morningstarStandardizedName: "Myanmar",
    isoCountryCode: "MM",
    name: "Mianmar (Birmânia)",
  },
  {
    morningstarStandardizedName: "Senegal",
    isoCountryCode: "SN",
    name: "Senegal",
  },
  {
    morningstarStandardizedName: "Gambia",
    isoCountryCode: "GM",
    name: "Gâmbia",
  },
  {
    morningstarStandardizedName: "Andorra",
    isoCountryCode: "AD",
    name: "Andorra",
  },
  {
    morningstarStandardizedName: "Saint Kitts and Nevis",
    isoCountryCode: "KN",
    name: "São Cristóvão e Névis",
  },
  {
    morningstarStandardizedName: "Cambodia",
    isoCountryCode: "KH",
    name: "Camboja",
  },
  {
    morningstarStandardizedName: "Thailand",
    isoCountryCode: "TH",
    name: "Tailândia",
  },
  {
    morningstarStandardizedName: "Cayman Islands",
    isoCountryCode: "KY",
    name: "Ilhas Cayman",
  },
  {
    morningstarStandardizedName: "New Caledonia",
    isoCountryCode: "NC",
    name: "Nova Caledônia",
  },
  {
    morningstarStandardizedName: "Sint Maarten",
    isoCountryCode: "SX",
    name: "Sint Maarten",
  },
  {
    morningstarStandardizedName: "Suriname",
    isoCountryCode: "SR",
    name: "Suriname",
  },
  {
    morningstarStandardizedName: "Kosovo",
    isoCountryCode: "XK",
    name: "Kosovo",
  },
  {
    morningstarStandardizedName: "Kuwait",
    isoCountryCode: "KW",
    name: "Kuwait",
  },
  {
    morningstarStandardizedName: "Micronesia, Federated States of",
    isoCountryCode: "FM",
    name: "Micronésia",
  },
  {
    morningstarStandardizedName: "Jordan",
    isoCountryCode: "JO",
    name: "Jordânia",
  },
  {
    morningstarStandardizedName: "Uganda",
    isoCountryCode: "UG",
    name: "Uganda",
  },
  {
    morningstarStandardizedName: "Singapore",
    isoCountryCode: "SG",
    name: "Singapura",
  },
  {
    morningstarStandardizedName: "Equatorial Guinea",
    isoCountryCode: "GQ",
    name: "Guiné Equatorial",
  },
  {
    morningstarStandardizedName: "Bosnia and Herzegovina",
    isoCountryCode: "BA",
    name: "Bósnia e Herzegovina",
  },
  {
    morningstarStandardizedName: "Tanzania, United Republic Of",
    isoCountryCode: "TZ",
    name: "Tanzânia",
  },
  {
    morningstarStandardizedName: "New Zealand",
    isoCountryCode: "NZ",
    name: "Nova Zelândia",
  },
  {
    morningstarStandardizedName: "Aruba",
    isoCountryCode: "AW",
    name: "Aruba",
  },
  {
    morningstarStandardizedName: "Macedonia, The Former Yugoslav Republic of",
    isoCountryCode: "MK",
    name: "Macedônia do Norte",
  },
  {
    morningstarStandardizedName: "Togo",
    isoCountryCode: "TG",
    name: "Togo",
  },
  {
    morningstarStandardizedName: "Zimbabwe",
    isoCountryCode: "ZW",
    name: "Zimbábue",
  },
  {
    morningstarStandardizedName: "Sri Lanka",
    isoCountryCode: "LK",
    name: "Sri Lanka",
  },
  {
    morningstarStandardizedName: "Malawi",
    isoCountryCode: "MW",
    name: "Malaui",
  },
  {
    morningstarStandardizedName: "Dominica",
    isoCountryCode: "DM",
    name: "Dominica",
  },
  {
    morningstarStandardizedName: "United Kingdom",
    isoCountryCode: "GB",
    name: "Reino Unido",
  },
  {
    morningstarStandardizedName: "Latvia",
    isoCountryCode: "LV",
    name: "Letônia",
  },
  {
    morningstarStandardizedName: "Bolivia",
    isoCountryCode: "BO",
    name: "Bolívia",
  },
  {
    morningstarStandardizedName: "Israel",
    isoCountryCode: "IL",
    name: "Israel",
  },
  {
    morningstarStandardizedName: "Congo, The Democratic Republic Of The",
    isoCountryCode: "CD",
    name: "Congo - Kinshasa",
  },
  {
    morningstarStandardizedName: "Belize",
    isoCountryCode: "BZ",
    name: "Belize",
  },
  {
    morningstarStandardizedName: "Mauritania",
    isoCountryCode: "MR",
    name: "Mauritânia",
  },
  {
    morningstarStandardizedName: "Vanuatu",
    isoCountryCode: "VU",
    name: "Vanuatu",
  },
  {
    morningstarStandardizedName: "Vietnam",
    isoCountryCode: "VN",
    name: "Vietnã",
  },
  {
    morningstarStandardizedName: "Iceland",
    isoCountryCode: "IS",
    name: "Islândia",
  },
  {
    morningstarStandardizedName: "Montenegro",
    isoCountryCode: "ME",
    name: "Montenegro",
  },
  {
    morningstarStandardizedName: "Paraguay",
    isoCountryCode: "PY",
    name: "Paraguai",
  },
  {
    morningstarStandardizedName: "Fiji",
    isoCountryCode: "FJ",
    name: "Fiji",
  },
  {
    morningstarStandardizedName: "Brazil",
    isoCountryCode: "BR",
    name: "Brasil",
  },
  {
    morningstarStandardizedName: "Portugal",
    isoCountryCode: "PT",
    name: "Portugal",
  },
  {
    morningstarStandardizedName: "Cameroon",
    isoCountryCode: "CM",
    name: "Camarões",
  },
  {
    morningstarStandardizedName: "Cuba",
    isoCountryCode: "CU",
    name: "Cuba",
  },
  {
    morningstarStandardizedName: "Oman",
    isoCountryCode: "OM",
    name: "Omã",
  },
  {
    morningstarStandardizedName: "Belgium",
    isoCountryCode: "BE",
    name: "Bélgica",
  },
  {
    morningstarStandardizedName: "Morocco",
    isoCountryCode: "MA",
    name: "Marrocos",
  },
  {
    morningstarStandardizedName: "Nauru",
    isoCountryCode: "NR",
    name: "Nauru",
  },
  {
    morningstarStandardizedName: "Niger",
    isoCountryCode: "NE",
    name: "Níger",
  },
  {
    morningstarStandardizedName: "Congo, Republic of the",
    isoCountryCode: "CG",
    name: "República do Congo",
  },
  {
    morningstarStandardizedName: "Venezuela",
    isoCountryCode: "VE",
    name: "Venezuela",
  },
  {
    morningstarStandardizedName: "Gabon",
    isoCountryCode: "GA",
    name: "Gabão",
  },
  {
    morningstarStandardizedName: "Angola",
    isoCountryCode: "AO",
    name: "Angola",
  },
  {
    morningstarStandardizedName: "Slovenia",
    isoCountryCode: "SI",
    name: "Eslovênia",
  },
  {
    morningstarStandardizedName: "Rwanda",
    isoCountryCode: "RW",
    name: "Ruanda",
  },
  {
    morningstarStandardizedName: "Sao Tome & Principe",
    isoCountryCode: "ST",
    name: "São Tomé e Príncipe",
  },
  {
    morningstarStandardizedName: "Cyprus",
    isoCountryCode: "CY",
    name: "Chipre",
  },
  {
    morningstarStandardizedName: "United States of America",
    isoCountryCode: "US",
    name: "Estados Unidos",
  },
  {
    morningstarStandardizedName: "Tuvalu",
    isoCountryCode: "TV",
    name: "Tuvalu",
  },
  {
    morningstarStandardizedName: "Chile",
    isoCountryCode: "CL",
    name: "Chile",
  },
  {
    morningstarStandardizedName: "United States",
    isoCountryCode: "US",
    name: "Estados Unidos",
  },
  {
    morningstarStandardizedName: "Moldova, Republic of",
    isoCountryCode: "MD",
    name: "Moldávia",
  },
  {
    morningstarStandardizedName: "Saudi Arabia",
    isoCountryCode: "SA",
    name: "Arábia Saudita",
  },
  {
    morningstarStandardizedName: "Nepal",
    isoCountryCode: "NP",
    name: "Nepal",
  },
  {
    morningstarStandardizedName: "Bahrain",
    isoCountryCode: "BH",
    name: "Barein",
  },
  {
    morningstarStandardizedName: "Viet Nam",
    isoCountryCode: "VN",
    name: "Vietnã",
  },
  {
    morningstarStandardizedName: "Slovakia",
    isoCountryCode: "SK",
    name: "Eslováquia",
  },
  {
    morningstarStandardizedName: "Kazakhstan",
    isoCountryCode: "KZ",
    name: "Cazaquistão",
  },
  {
    morningstarStandardizedName: "Mali",
    isoCountryCode: "ML",
    name: "Mali",
  },
  {
    morningstarStandardizedName: "Uruguay",
    isoCountryCode: "UY",
    name: "Uruguai",
  },
  {
    morningstarStandardizedName: "Indonesia",
    isoCountryCode: "ID",
    name: "Indonésia",
  },
  {
    morningstarStandardizedName: "China",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    morningstarStandardizedName: "Guinea-Bissau",
    isoCountryCode: "GW",
    name: "Guiné-Bissau",
  },
  {
    morningstarStandardizedName: "Marshall Islands",
    isoCountryCode: "MH",
    name: "Ilhas Marshall",
  },
  {
    morningstarStandardizedName: "Kenya",
    isoCountryCode: "KE",
    name: "Quênia",
  },
  {
    morningstarStandardizedName: "Syrian Arab Republic",
    isoCountryCode: "SY",
    name: "Síria",
  },
  {
    morningstarStandardizedName: "US",
    isoCountryCode: "US",
    name: "Estados Unidos",
  },
  {
    morningstarStandardizedName: "South Sudan",
    isoCountryCode: "SS",
    name: "Sudão do Sul",
  },
  {
    morningstarStandardizedName: "Croatia",
    isoCountryCode: "HR",
    name: "Croácia",
  },
  {
    morningstarStandardizedName: "Albania",
    isoCountryCode: "AL",
    name: "Albânia",
  },
  {
    morningstarStandardizedName: "Jamaica",
    isoCountryCode: "JM",
    name: "Jamaica",
  },
  {
    morningstarStandardizedName: "Denmark",
    isoCountryCode: "DK",
    name: "Dinamarca",
  },
  {
    morningstarStandardizedName: "Antigua and Barbuda",
    isoCountryCode: "AG",
    name: "Antígua e Barbuda",
  },
  {
    morningstarStandardizedName: "Nicaragua",
    isoCountryCode: "NI",
    name: "Nicarágua",
  },
  {
    morningstarStandardizedName: "Libyan Arab Jamahiriya",
    isoCountryCode: "LY",
    name: "Líbia",
  },
  {
    morningstarStandardizedName: "Burundi",
    isoCountryCode: "BI",
    name: "Burundi",
  },
  {
    morningstarStandardizedName: "Bermuda",
    isoCountryCode: "BM",
    name: "Bermudas",
  },
  {
    morningstarStandardizedName: "Italy",
    isoCountryCode: "IT",
    name: "Itália",
  },
  {
    morningstarStandardizedName: "Puerto Rico",
    isoCountryCode: "PR",
    name: "Porto Rico",
  },
  {
    morningstarStandardizedName: "Chad",
    isoCountryCode: "TD",
    name: "Chade",
  },
  {
    morningstarStandardizedName: "Turkmenistan",
    isoCountryCode: "TM",
    name: "Turcomenistão",
  },
  {
    morningstarStandardizedName: "Haiti",
    isoCountryCode: "HT",
    name: "Haiti",
  },
  {
    morningstarStandardizedName: "Benin",
    isoCountryCode: "BJ",
    name: "Benin",
  },
  {
    morningstarStandardizedName: "Macao",
    isoCountryCode: "MO",
    name: "Macau, RAE da China",
  },
  {
    morningstarStandardizedName: "Germany",
    isoCountryCode: "DE",
    name: "Alemanha",
  },
  {
    morningstarStandardizedName: "Romania",
    isoCountryCode: "RO",
    name: "Romênia",
  },
  {
    morningstarStandardizedName: "Malaysia",
    isoCountryCode: "MY",
    name: "Malásia",
  },
  {
    morningstarStandardizedName: "Palestinian Territory, Occupied",
    isoCountryCode: "PS",
    name: "Territórios palestinos",
  },
  {
    morningstarStandardizedName: "Ethiopia",
    isoCountryCode: "ET",
    name: "Etiópia",
  },
  {
    morningstarStandardizedName: "Bhutan",
    isoCountryCode: "BT",
    name: "Butão",
  },
  {
    morningstarStandardizedName: "Guyana",
    isoCountryCode: "GY",
    name: "Guiana",
  },
  {
    morningstarStandardizedName: "Saint Lucia",
    isoCountryCode: "LC",
    name: "Santa Lúcia",
  },
  {
    morningstarStandardizedName: "Djibouti",
    isoCountryCode: "DJ",
    name: "Djibuti",
  },
  {
    morningstarStandardizedName: "Swaziland",
    isoCountryCode: "SZ",
    name: "Essuatíni",
  },
  {
    morningstarStandardizedName: "Liberia",
    isoCountryCode: "LR",
    name: "Libéria",
  },
  {
    morningstarStandardizedName: "Cape Verde",
    isoCountryCode: "CV",
    name: "Cabo Verde",
  },
  {
    morningstarStandardizedName: "Azerbaijan",
    isoCountryCode: "AZ",
    name: "Azerbaijão",
  },
  {
    morningstarStandardizedName: "Switzerland",
    isoCountryCode: "CH",
    name: "Suíça",
  },
  {
    morningstarStandardizedName: "China, People's Republic of",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    morningstarStandardizedName: "Papua New Guinea",
    isoCountryCode: "PG",
    name: "Papua-Nova Guiné",
  },
  {
    morningstarStandardizedName: "Algeria",
    isoCountryCode: "DZ",
    name: "Argélia",
  },
  {
    morningstarStandardizedName: "Yemen",
    isoCountryCode: "YE",
    name: "Iêmen",
  },
  {
    morningstarStandardizedName: "Luxembourg",
    isoCountryCode: "LU",
    name: "Luxemburgo",
  },
  {
    morningstarStandardizedName: "Norway",
    isoCountryCode: "NO",
    name: "Noruega",
  },
  {
    morningstarStandardizedName: "Nigeria",
    isoCountryCode: "NG",
    name: "Nigéria",
  },
  {
    morningstarStandardizedName: "American Samoa",
    isoCountryCode: "AS",
    name: "Samoa Americana",
  },
  {
    morningstarStandardizedName: "Saint Vincent and the Grenadines",
    isoCountryCode: "VC",
    name: "São Vicente e Granadinas",
  },
  {
    morningstarStandardizedName: "India",
    isoCountryCode: "IN",
    name: "Índia",
  },
  {
    morningstarStandardizedName: "Palau",
    isoCountryCode: "PW",
    name: "Palau",
  },
  {
    morningstarStandardizedName: "Tunisia",
    isoCountryCode: "TN",
    name: "Tunísia",
  },
  {
    morningstarStandardizedName: "Bangladesh",
    isoCountryCode: "BD",
    name: "Bangladesh",
  },
  {
    morningstarStandardizedName: "French Polynesia",
    isoCountryCode: "PF",
    name: "Polinésia Francesa",
  },
  {
    morningstarStandardizedName: "Sierra Leone",
    isoCountryCode: "SL",
    name: "Serra Leoa",
  },
  {
    morningstarStandardizedName: "Burkina Faso",
    isoCountryCode: "BF",
    name: "Burquina Faso",
  },
  {
    morningstarStandardizedName: "Japan",
    isoCountryCode: "JP",
    name: "Japão",
  },
  {
    morningstarStandardizedName: "Trinidad and Tobago",
    isoCountryCode: "TT",
    name: "Trinidad e Tobago",
  },
  {
    morningstarStandardizedName: "Ecuador",
    isoCountryCode: "EC",
    name: "Equador",
  },
  {
    morningstarStandardizedName: "Panama",
    isoCountryCode: "PA",
    name: "Panamá",
  },
  {
    morningstarStandardizedName: "Ghana",
    isoCountryCode: "GH",
    name: "Gana",
  },
  {
    morningstarStandardizedName: "Pakistan",
    isoCountryCode: "PK",
    name: "Paquistão",
  },
  {
    morningstarStandardizedName: "Bulgaria",
    isoCountryCode: "BG",
    name: "Bulgária",
  },
  {
    morningstarStandardizedName: "Seychelles",
    isoCountryCode: "SC",
    name: "Seicheles",
  },
  {
    morningstarStandardizedName: "Malta",
    isoCountryCode: "MT",
    name: "Malta",
  },
  {
    morningstarStandardizedName: "UK",
    isoCountryCode: "GB",
    name: "Reino Unido",
  },
  {
    morningstarStandardizedName: "Iraq",
    isoCountryCode: "IQ",
    name: "Iraque",
  },
  {
    morningstarStandardizedName: "People’s Republic of China",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    morningstarStandardizedName: "Curaçao",
    isoCountryCode: "CW",
    name: "Curaçao",
  },
  {
    morningstarStandardizedName: "Virgin Islands, U.S.",
    isoCountryCode: "VI",
    name: "Ilhas Virgens Americanas",
  },
  {
    morningstarStandardizedName: "Sweden",
    isoCountryCode: "SE",
    name: "Suécia",
  },
  {
    morningstarStandardizedName: "United Arab Emirates",
    isoCountryCode: "AE",
    name: "Emirados Árabes Unidos",
  },
  {
    morningstarStandardizedName: "Eritrea",
    isoCountryCode: "ER",
    name: "Eritreia",
  },
  {
    morningstarStandardizedName: "Spain",
    isoCountryCode: "ES",
    name: "Espanha",
  },
  {
    morningstarStandardizedName: "Guinea",
    isoCountryCode: "GN",
    name: "Guiné",
  },
  {
    morningstarStandardizedName: "Hong Kong",
    isoCountryCode: "HK",
    name: "Hong Kong, RAE da China",
  },
  {
    morningstarStandardizedName: "Isle of Man",
    isoCountryCode: "IM",
    name: "Ilha de Man",
  },
  {
    morningstarStandardizedName: "Argentina",
    isoCountryCode: "AR",
    name: "Argentina",
  },
  {
    morningstarStandardizedName: "Dominican Republic",
    isoCountryCode: "DO",
    name: "República Dominicana",
  },
  {
    morningstarStandardizedName: "Zambia",
    isoCountryCode: "ZM",
    name: "Zâmbia",
  },
  {
    morningstarStandardizedName: "Austria",
    isoCountryCode: "AT",
    name: "Áustria",
  },
  {
    morningstarStandardizedName: "Australia",
    isoCountryCode: "AU",
    name: "Austrália",
  },
  {
    morningstarStandardizedName: "Kiribati",
    isoCountryCode: "KI",
    name: "Quiribati",
  },
  {
    morningstarStandardizedName: "Grenada",
    isoCountryCode: "GD",
    name: "Granada",
  },
  {
    morningstarStandardizedName: "Kyrgyzstan",
    isoCountryCode: "KG",
    name: "Quirguistão",
  },
  {
    morningstarStandardizedName: "Madagascar",
    isoCountryCode: "MG",
    name: "Madagascar",
  },
  {
    morningstarStandardizedName: "Egypt",
    isoCountryCode: "EG",
    name: "Egito",
  },
  {
    morningstarStandardizedName: "Korea, Republic of",
    isoCountryCode: "KR",
    name: "Coreia do Sul",
  },
  {
    morningstarStandardizedName: "Brunei Darussalam",
    isoCountryCode: "BN",
    name: "Brunei",
  },
  {
    morningstarStandardizedName: "Ukraine",
    isoCountryCode: "UA",
    name: "Ucrânia",
  },
  {
    morningstarStandardizedName: "Bahamas",
    isoCountryCode: "BS",
    name: "Bahamas",
  },
  {
    morningstarStandardizedName: "Samoa",
    isoCountryCode: "WS",
    name: "Samoa",
  },
  {
    morningstarStandardizedName: "Armenia",
    isoCountryCode: "AM",
    name: "Armênia",
  },
  {
    morningstarStandardizedName: "Côte d'Ivoire",
    isoCountryCode: "CI",
    name: "Costa do Marfim",
  },
  {
    morningstarStandardizedName: "Georgia",
    isoCountryCode: "GE",
    name: "Geórgia",
  },
  {
    morningstarStandardizedName: "Lao People's Democratic Republic",
    isoCountryCode: "LA",
    name: "Laos",
  },
  {
    morningstarStandardizedName: "Taiwan",
    isoCountryCode: "TW",
    name: "Taiwan",
  },
  {
    morningstarStandardizedName: "Russian Federation",
    isoCountryCode: "RU",
    name: "Rússia",
  },
  {
    morningstarStandardizedName: "Finland",
    isoCountryCode: "FI",
    name: "Finlândia",
  },
  {
    morningstarStandardizedName: "Afghanistan",
    isoCountryCode: "AF",
    name: "Afeganistão",
  },
  {
    morningstarStandardizedName: "Faroe Islands",
    isoCountryCode: "FO",
    name: "Ilhas Faroé",
  },
  {
    morningstarStandardizedName: "Jersey",
    isoCountryCode: "JE",
    name: "Jersey",
  },
  {
    morningstarStandardizedName: "Mexico",
    isoCountryCode: "MX",
    name: "México",
  },
  {
    morningstarStandardizedName: "Tajikistan",
    isoCountryCode: "TJ",
    name: "Tadjiquistão",
  },
  {
    morningstarStandardizedName: "Botswana",
    isoCountryCode: "BW",
    name: "Botsuana",
  },
  {
    morningstarStandardizedName: "Korea, Democratic People's Republic of",
    isoCountryCode: "KP",
    name: "Coreia do Norte",
  },
  {
    morningstarStandardizedName: "Czech Republic",
    isoCountryCode: "CZ",
    name: "Tchéquia",
  },
  {
    morningstarStandardizedName: "Canada",
    isoCountryCode: "CA",
    name: "Canadá",
  },
  {
    morningstarStandardizedName: "Greenland",
    isoCountryCode: "GL",
    name: "Groenlândia",
  },
  {
    morningstarStandardizedName: "Mauritius",
    isoCountryCode: "MU",
    name: "Maurício",
  },
  {
    morningstarStandardizedName: "Liechtenstein",
    isoCountryCode: "LI",
    name: "Liechtenstein",
  },
  {
    morningstarStandardizedName: "Honduras",
    isoCountryCode: "HN",
    name: "Honduras",
  },
  {
    morningstarStandardizedName: "Sudan",
    isoCountryCode: "SD",
    name: "Sudão",
  },
  {
    morningstarStandardizedName: "Philippines",
    isoCountryCode: "PH",
    name: "Filipinas",
  },
  {
    morningstarStandardizedName: "Netherlands",
    isoCountryCode: "NL",
    name: "Países Baixos",
  },
  {
    morningstarStandardizedName: "Belarus",
    isoCountryCode: "BY",
    name: "Bielorrússia",
  },
  {
    morningstarStandardizedName: "Poland",
    isoCountryCode: "PL",
    name: "Polônia",
  },
  {
    morningstarStandardizedName: "Mongolia",
    isoCountryCode: "MN",
    name: "Mongólia",
  },
  {
    morningstarStandardizedName: "Monaco",
    isoCountryCode: "MC",
    name: "Mônaco",
  },
  {
    morningstarStandardizedName: "Guatemala",
    isoCountryCode: "GT",
    name: "Guatemala",
  },
  {
    morningstarStandardizedName: "Iran, Islamic Republic of",
    isoCountryCode: "IR",
    name: "Irã",
  },
  {
    morningstarStandardizedName: "Uzbekistan",
    isoCountryCode: "UZ",
    name: "Uzbequistão",
  },
  {
    morningstarStandardizedName: "Namibia",
    isoCountryCode: "NA",
    name: "Namíbia",
  },
  {
    morningstarStandardizedName: "Solomon Islands",
    isoCountryCode: "SB",
    name: "Ilhas Salomão",
  },
  {
    morningstarStandardizedName: "El Salvador",
    isoCountryCode: "SV",
    name: "El Salvador",
  },
  {
    morningstarStandardizedName: "Hungary",
    isoCountryCode: "HU",
    name: "Hungria",
  },
  {
    morningstarStandardizedName: "Estonia",
    isoCountryCode: "EE",
    name: "Estônia",
  },
  {
    morningstarStandardizedName: "Guam",
    isoCountryCode: "GU",
    name: "Guam",
  },
  {
    morningstarStandardizedName: "Maldives",
    isoCountryCode: "MV",
    name: "Maldivas",
  },
  {
    morningstarStandardizedName: "Somalia",
    isoCountryCode: "SO",
    name: "Somália",
  },
  {
    morningstarStandardizedName: "Northern Mariana Islands",
    isoCountryCode: "MP",
    name: "Ilhas Marianas do Norte",
  },
  {
    morningstarStandardizedName: "Russia",
    isoCountryCode: "RU",
    name: "Rússia",
  },
  {
    morningstarStandardizedName: "South Africa",
    isoCountryCode: "ZA",
    name: "África do Sul",
  },
  {
    morningstarStandardizedName: "Lesotho",
    isoCountryCode: "LS",
    name: "Lesoto",
  },
];
